// Golden-angle distribution for visually distinct colors across 2–8 workspaces.
// Reuse same hash-derived color across all surfaces (deterministic, no config).

export function workspaceColor(id: number): string {
  return `hsl(${(id * 137) % 360}, 55%, 50%)`;
}

// Cross-workspace card treatment — matches the Overview `.ov-card` aesthetic
// (FEAT-039): 4px workspace-colored left border + a faint tint of the same hue.
// Applied only to cards from a workspace other than the active one, so the
// tint reads as "this belongs to another workspace."
export function workspaceBorderStyle(
  id: number
): React.CSSProperties {
  const color = workspaceColor(id);
  return {
    borderLeft: `4px solid ${color}`,
    background: `color-mix(in oklab, ${color} 6%, var(--surface))`,
  };
}
